// App branding, configurable at runtime via container env (window.__ENV__),
// with build-time (process.env) and hardcoded fallbacks. See runtimeEnv.js.
import { getEnv } from "./runtimeEnv";

export const APP_TITLE = getEnv("REACT_APP_APP_TITLE", "Life Pillars");
export const APP_SUBTITLE = getEnv("REACT_APP_APP_SUBTITLE", "Weekly Hub");
// Full name for places that show the title on one line (browser tab, login).
export const APP_FULL_TITLE = `${APP_TITLE} ${APP_SUBTITLE}`.trim();
